export const getMessageElement = (container, messageId) => {
  if (!container || messageId === null || messageId === undefined) return null;

  return container.querySelector(`[data-chat-message-id="${String(messageId)}"]`);
};

export const captureScrollSnapshot = (container) => {
  if (!container) return null;

  const messageElements = Array.from(
    container.querySelectorAll('[data-chat-message-id]'),
  );

  const anchorElement =
    messageElements.find((element) => {
      const elementBottom = element.offsetTop + element.offsetHeight;

      return elementBottom >= container.scrollTop;
    }) ?? messageElements[0] ?? null;

  return {
    scrollHeight: container.scrollHeight,
    scrollTop: container.scrollTop,
    anchorMessageId: anchorElement?.dataset?.chatMessageId ?? null,
    anchorOffsetTop:
      anchorElement ? anchorElement.offsetTop - container.scrollTop : null,
  };
};

export const restoreScrollAfterPrepend = (container, snapshot) => {
  if (!container || !snapshot) return;

  if (snapshot.anchorMessageId) {
    const anchorElement = getMessageElement(container, snapshot.anchorMessageId);

    if (anchorElement && snapshot.anchorOffsetTop !== null) {
      container.scrollTop = anchorElement.offsetTop - snapshot.anchorOffsetTop;
      return;
    }
  }

  const delta = container.scrollHeight - snapshot.scrollHeight;
  container.scrollTop = snapshot.scrollTop + delta;
};

export const scrollMessageToCenter = (container, messageId, behavior = 'smooth') => {
  const element = getMessageElement(container, messageId);

  if (!container || !element) return false;

  const nextScrollTop =
    element.offsetTop - container.clientHeight / 2 + element.clientHeight / 2;

  container.scrollTo({
    top: Math.max(nextScrollTop, 0),
    behavior,
  });

  return true;
};
